import React, { useEffect, useState } from "react";
import { Container, ModalDialog } from "../../../components";
import { Icon, Text, Heading, Button } from "@telia/teddy";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import PAGES from "../../../../../constants/pages";
import { RootState } from "../../../../../models";
import {
    isBankIdVerified as isBankIdVerifiedSelector,
    isBankIdPerformed as isBankIdPerformedSelector,
    getCustomer,
} from "../../../authentication/state/selectors";
import "./PersonalDetails.less";
import BankIdSection from "../../../checkout/components/molecules/BankIdSectionTeliaBroker/BankIdSectionTeliaBroker";
import DsfMismatchForm from "../../../checkout/components/organisms/DsfMismatchForm/DsfMismatchForm";
import { resetOrder } from "../../../checkout/state/actions/phoneNumberActions";
import ContinueSection from "../../components/molecules/ContinueSection/ContinueSection";
import RegisterPrepaidSimCard from "../../components/organisms/RegisterPrepaidForm/RegisterPrepaidForm";
import { registerSimCard, verifyUpdatedName } from "../../state/actions/registrationActions";
import { isOrderComplete as isOrderCompleteSelector } from "../../state/selectors";
import TEXT from "../../text-consts";

const PersonalDetails: React.FC = () => {
    const dispatch = useDispatch();
    const isBankIdVerified = useSelector((state: RootState) => isBankIdVerifiedSelector(state));
    const isBankIdPerformed = useSelector((state: RootState) => isBankIdPerformedSelector(state));
    const userName = useSelector((state: RootState) => getCustomer(state));

    const [showLogOutBankIdModal, setShowLogoutBankIdModal] = useState(false);
    const location = useLocation();

    const isOrderCompleted = useSelector((state: RootState) => isOrderCompleteSelector(state));
    useEffect(() => {
        if (isOrderCompleted) {
            window.location.assign(PAGES.PREPAID.REGISTRATION.RECEIPT.URL);
        }
    }, [isOrderCompleted]);

    return (
        <div className="prepaid-registration">
            {!isBankIdPerformed && (
                <>
                    <Heading mb="100" as="h1" variant="title-600" className="prepaid-registration__heading">
                        {TEXT.REGISTRATION.HEADING}
                    </Heading>
                    <Text mb="100" className="prepaid-registration__ingress">
                        {TEXT.REGISTRATION.INGRESS}
                    </Text>
                    <BankIdSection referer="prepaidRegistration" typeId="prepaid_registration_bankid" />
                    <div
                        className="prepaid-registration__notbankid"
                        dangerouslySetInnerHTML={{ __html: TEXT.REGISTRATION.NOT_BANKID }}
                    />
                </>
            )}
            {!isBankIdVerified && isBankIdPerformed && (
                <>
                    <Heading mb="100" as="h1" variant="title-600" className="prepaid-registration__heading">
                        {TEXT.REGISTRATION.HEADING}
                    </Heading>
                    <DsfMismatchForm
                        update={async (firstName, lastName) => dispatch(verifyUpdatedName(firstName, lastName))}
                        setShowLogoutBankIdModal={(show) => setShowLogoutBankIdModal(show)}
                    />
                    <ContinueSection path={location.pathname} />
                </>
            )}
            {isBankIdVerified && isBankIdPerformed && (
                <>
                    <Heading mb="100" as="h1" variant="title-600">
                        {TEXT.REGISTRATION.BANK_ID_VERIFIED.HEADING}
                    </Heading>
                    <Text mb="100" className="prepaid-registration__ingress">
                        {TEXT.REGISTRATION.SIMCARD.USERINFO}
                    </Text>
                    <Container size="small" className="prepaid-registration__contactInfo" data-cy="contact-info-form">
                        <Heading mb="100" as="h2" variant="title-100" data-di-mask>
                            {userName}
                        </Heading>
                        <div className="prepaid-registration__contactInfo__bankid-btn">
                            <Button
                                type="button"
                                variant="text-underline"
                                className="contact-card-container__bankid-btn"
                                onClick={() => setShowLogoutBankIdModal(true)}
                            >
                                {TEXT.PERSONAL_DETAILS.VERIFICATION.RESET_BANKID}
                                <Icon className="contact-card-container__bankid-icon" name="logout" />
                            </Button>
                        </div>
                    </Container>
                    <Container
                        className="beta-checkout__section"
                        size="small"
                        whiteBg
                        noPaddingTop
                        data-cy="contact-info-form"
                    >
                        <RegisterPrepaidSimCard onSubmitDetails={() => dispatch(registerSimCard())} />
                    </Container>
                    <ContinueSection path={location.pathname} />
                </>
            )}
            {showLogOutBankIdModal && (
                <ModalDialog
                    className="contact-card-container__logout-bankid"
                    size="small"
                    submitText="Ja, logg meg ut"
                    closeText="Nei, bli på siden"
                    closeKind="secondary"
                    heading="Ønsker du å logge ut av BankID?"
                    name="log-out-bank-id-modal"
                    onSubmit={() => {
                        dispatch(resetOrder());
                        setShowLogoutBankIdModal(false);
                    }}
                    onClose={() => setShowLogoutBankIdModal(false)}
                />
            )}
        </div>
    );
};

export default PersonalDetails;
